const moment = require('moment');

const SourceTableMap = {
    livepic : 'dws.dws_livein_base_action_mix',
    livein  : 'dws.dws_livein_base_action_mix',
    jojoy   : 'dws.dws_jojoy_base_action_etp',
    misu    : 'dws.dws_misu_base_action_etp',
    livestatus  : 'dws.dws_livestatus_base_action_mix',
    'KeyBoard' : `dwd.dwd_keyboard_base_events_etp`
}


function genAppFunnelSqls(form) {

    let { system, app, daterange, appVersion, country, events } = form;
    let [ start, end ] = daterange;
    let [ name, src ] = app.split(':');

    let ps = `date_time >= '${start}' and date_time <= '${end}' and app_name = '${app}'`;

    if (country.length > 0) {
        ps += ` and country in ('${country.join("', '")}')`;
    }

    if (appVersion.length > 0) {
        ps += ` and app_version in ('${appVersion.join("', '")}')`;
    }

    let sqls = [];

    events.forEach((ev) => {

        let eps = ps;
        // if (src == 'flurry') {
        //     eps += ` and event_name = '${ev.name}'`;
        // } else {
        //     eps += ` and event = '${ev.name}'`;
        // }

        eps += ` and event = '${ev.name}'`;

        ev.params.forEach((ep) => {
            if (!ep.key.trim() || !ep.value.trim()) {
                return
            }
            eps += ` and get_json_object(properties,'$.${ep.key}') = '${ep.value}'`;
        })


        let sql = `select count(distinct event_time) as pv, count(distinct user_id) as uv from ${SourceTableMap[system]} where ${eps}`;
        sqls.push(sql);

    })

    return sqls;

}


function genFunnelPVSqls(form) {

  let { app, daterange, appVersion, country, events } = form;
  app = app.toLowerCase();
  let [start, end] = daterange;

  let ps = `date_time >= '${start}' and date_time <= '${end}' and app = '${app}'`;

  if (country.length > 0) {
    ps += ` and country_iso in ('${country.join("', '")}')`;
  }

  if (appVersion.length > 0) {
    ps += ` and app_version in ('${appVersion.join("', '")}')`;
  }

  let sqls = [];
  events.forEach((ev) => {

    let eps = ps;
    eps += ` and event_name = '${ev.name}'`;
    ev.params.forEach((ep) => {
      if (!ep.key.trim() || !ep.value.trim()) {
        return
      }
      eps += ` and event_parameters.${ep.key} = '${ep.value}'`;
    })

    let sql = `select sum(pv) as pv, 0 as uv from dws.dws_mod_ad_action_stat_di where ${eps}`;

    sqls.push(sql);
  })
  return sqls;

};

function genFunnelUVPVSqls(form) {

  let { app, daterange, appVersion, country, events } = form;
  app = app.toLowerCase();

  let start = moment(daterange[0], 'YYYY-MM-DD');
  let end = moment(daterange[1], 'YYYY-MM-DD');

  let dates = [];

  while (start <= end) {
    let d = start.format('YYYYMMDD');
    dates.push(d)
    start = start.add(1, 'days');
  }

  let ps = `app = '${app}'`;

  if (country.length > 0) {
    ps += ` and country_iso in ('${country.join("', '")}')`;
  }

  if (appVersion.length > 0) {
    ps += ` and app_version in ('${appVersion.join("', '")}')`;
  }

  let sqls = [];
  events.forEach((ev) => {

    let eps = ps;
    eps += ` and event_name = '${ev.name}'`;
    ev.params.forEach((ep) => {
      if (!ep.key.trim() || !ep.value.trim()) {
        return
      }
      eps += ` and event_parameters.${ep.key} = '${ep.value}'`;
    })

    let src = '';
    dates.forEach((dt) => {

      let s0 = `select android_id, pv from dws.dws_mod_ad_action_device_${dt} where ${eps}`;

      if (!src) {
        src = s0;
      } else {
        src += ` union all ${s0}`;
      }
    })

    let sql = `select sum(pv) as pv, count(distinct android_id) as uv from (${src})`;
    sqls.push(sql);
  })
  return sqls;
};

function genFunnelSqls(form) {

    let { system, daterange } = form;
    if (system == 'mod') {

        let [start, end] = daterange;
        if (start == end) {
            return genFunnelUVPVSqls(form);
        }

        return genFunnelPVSqls(form);
    }

    return genAppFunnelSqls(form);

}

function genModTrendSqls(daterange, events) {

    let [start, end] = daterange;
    
    let sqls = [];
    
    events.forEach((ev) => {
    
        let {app, appVersion, country, name, params } = ev;
    
        app = app.toLowerCase();
        let ps = `date_time >= '${start}' and date_time <= '${end}' and app = '${app}'`;
    
        if (country.length > 0) {
            ps += ` and country in ('${country.join("', '")}')`;
        }
    
        if (appVersion.length > 0) {
            ps += ` and app_version in ('${appVersion.join("', '")}')`;
        }
    
        ps += ` and event_name = '${ev.name}'`;
        ev.params.forEach((ep) => {
            if (!ep.key.trim() || !ep.value.trim()) {
                return
            }
            ps += ` and event_parameters.${ep.key} = '${ep.value}'`;
        })
    
        let sql = `select date_time::varchar as "date", sum(pv) as pv, 0 as uv from dws.dws_mod_ad_action_stat_di where ${ps} group by 1 order by 1`;
    
        sqls.push(sql);
    
    })
    
    return sqls;

}


function genAppTrendSqls(daterange, events) {

    let [start, end] = daterange;
    
    let sqls = [];
    
    events.forEach((ev) => {
    
        let { system, app, appVersion, country, name, params } = ev;
        let [ _, src ] = app.split(':');

        app = app.toLowerCase();
        let ps = `date_time >= '${start}' and date_time <= '${end}' and app_name = '${app}'`;
    
        if (country.length > 0) {
            ps += ` and country in ('${country.join("', '")}')`;
        }
    
        if (appVersion.length > 0) {
            ps += ` and app_version in ('${appVersion.join("', '")}')`;
        }
    
        // if (src == 'flurry') {
        //     ps += ` and event_name = '${ev.name}'`;
        // } else {
        //     ps += ` and event = '${ev.name}'`;
        // }

        ps += ` and event = '${ev.name}'`;

        ev.params.forEach((ep) => {
            if (!ep.key.trim() || !ep.value.trim()) {
                return
            }
            ps += ` and get_json_object(properties,'$.${ep.key}') = '${ep.value}'`;
        })
    
        let sql = `select CAST(date_time AS VARCHAR) AS date, count(distinct event_time) as pv,  count(distinct user_id) as uv from ${SourceTableMap[system]} where ${ps} group by 1 order by 1`;
    
        sqls.push(sql);
    
    })
    
    return sqls;

}

function genTrendSqls(daterange, form) {

    let system = form[0].system;
    console.log('system\n',system)

    if (system == 'mod') {
        return genModTrendSqls(daterange, form);
    }
    
    return genAppTrendSqls(daterange, form);
 
}

module.exports = {
    genTrendSqls,
    genFunnelSqls,
};

